import { useDispatch } from 'react-redux'
import BlogFooter from '../../../components/blog/Footer'
import { gotoLogIn } from '../../../redux/actions/AuthActions'

import { AppContainer, Body, Button, ButtonLink, Container, Content, H2, Image, MobileHeading, Show, Text } from '../landing.styles.js'

import Brands from '../Brands'
import FooterBanner from '../FooterBanner'
import Header from '../Header'
import Join from '../Join'
import Reviews from '../Reviews'

import headerBg from './header-bg.png'
import img1 from './img1.png'
import img2 from './img2.png'
import img3 from './img3.png'
import img4 from './img4.png'
import img5 from './img5.png'
import img6 from './img6.png'

const Office = () => {
  const dispatch = useDispatch()

  const openLogin = () => {
    dispatch(gotoLogIn())
  }
  return (
    <div>
      <Header
        title="Design Your Home Office Layout with Our Office Design App"
        subtitle="Easily design, decorate, and visualize your home office layout using the top-rated office design app."
        bg={headerBg}
        meta={{
          title: 'Office Design App | Design Your Home Office Layout and Decor',
          description: 'Use our office design app to customize your home office layout, place furniture, and explore workspace design ideas. Visualize your ideal office and create a setup that fits your workflow.'
        }}
        alt="Modern home office designs created with virtual layout app"
      />
      <Join
        title="Join 10 Million+ Users Designing Offices with"
        description={
          <>
            Use the DecorMatters home office design app to plan your office layout, try furniture, and decorate your workspace virtually. Explore office decor ideas, create a layout that fits your needs, and transform your work-from-home setup into a
            productive, stylish space.
          </>
        }
      />
      <Body>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Customize Your Office Layout with Our Home Office Design App</H2>
            </Show>
            <Text>
              Design your office layout, choose furniture, and decorate your home office with ease. With the DecorMatters office design app, you can visualize workspace layout ideas and experiment with furniture, lighting, and decor. Use the app to
              add and arrange:
              <br />
              <br />
              ● Office furniture (desks, chairs, storage)
              <br />
              ● Lighting and lamps
              <br />
              ● Wall decor and art
              <br />
              ● Rugs and flooring
              <br />
              ● Plants and greenery
              <br />
              ● And more
              <br />
              <br />
              Create the perfect home office that matches your workflow and style.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Customize Your Office Layout with Our Home Office Design App</H2>
            </Show>
            <Image src={img1} alt="Office furniture and lighting arranged in DecorMatters app" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Get Office Design Ideas from a Creative Community</H2>
            </Show>
            <Text>
              Join millions using our home office design app to share layouts, get feedback, and improve your workspace. From real-time suggestions to design challenges, DecorMatters helps you refine your home office with crowd-sourced inspiration
              and expert-backed ideas.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Get Office Design Ideas from a Creative Community</H2>
            </Show>
            <Image src={img2} alt="Shared workspace layout from DecorMatters design community featuring workspace inspiration" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Smart Tools to Design Your Home Office Like a Pro</H2>
            </Show>
            <Text>
              DecorMatters uses cutting-edge features like augmented reality and AI to help you plan and decorate your home office. Visualize furniture in your space, get layout suggestions, and explore product ideas — all with the most advanced
              virtual design tools at your fingertips.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Smart Tools to Design Your Home Office Like a Pro</H2>
            </Show>
            <Image src={img3} alt="augmented reality feature previewing a chair in a home office using virtual design tools" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Browse Office Furniture and Decor Ideas in One App</H2>
            </Show>
            <Text>
              Find everything you need to decorate your home office — from desks and chairs to lighting and wall art. Use our office design app to test different layouts, discover new workspace design ideas, and shop real furniture pieces directly
              within the app. Plan your layout and bring it to life with styles that match your goals and space.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Browse Office Furniture and Decor Ideas in One App</H2>
            </Show>
            <Image src={img4} alt="office desk and storage furniture selected from a product catalog within the app" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Unlock Advanced Office Design Tools</H2>
            </Show>
            <Text>
              Upgrade to DecorMatters Premium and access powerful features that help you customize every detail of your workspace. Upload real photos, visualize furniture with AR, and save your favorite products — all in one streamlined design
              experience.
              <br />
              <br />
              ● Upload your home office for accurate visual planning
              <br />
              ● Use the AR ruler to preview furniture in real space
              <br />
              ● Save decor and products you love
              <br />
              ● Remove backgrounds for clean, realistic layouts
              <br />● Access exclusive workspace design tools and updates
            </Text>
            <Button onClick={openLogin}>Unlock Premium Tools</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Unlock Advanced Office Design Tools</H2>
            </Show>
            <Image src={img5} alt="Comparison screen of free and premium office design features in the DecorMatters app" />
          </MobileHeading>
        </Container>
        <AppContainer>
          <Container>
            <Show on="mobile">
              <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                Start Designing Now
              </ButtonLink>
            </Show>
            <Image src={img6} alt="Mobile phone screen showing a completed home office design layout using the app" />
            <Content>
              <H2>Start Designing Your Dream Office Today</H2>
              <Text>
                Download the DecorMatters office design app to plan your workspace, arrange furniture, and decorate your home office with ease. Whether you're upgrading a work-from-home setup or designing a brand-new space, our app gives you
                everything you need to visualize and customize your perfect office.
              </Text>
              <Show on="desktop">
                <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                  Start Designing Now
                </ButtonLink>
              </Show>
            </Content>
          </Container>
        </AppContainer>
      </Body>
      <Brands />
      <Reviews />
      <FooterBanner />
      <BlogFooter />
    </div>
  )
}

export default Office
